export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig();
    const token = useCookie("access_token");
    // const { openSnackbar } = useSnackbar();
    const publicApi = $fetch.create({
        baseURL: config.public.baseURL,

        onRequest({ options }) {
            options.headers.set("accept", "application/json");
            if (token.value) {
                options.headers = options.headers || {};
                options.headers.set("Authorization", token.value);
            }
        },
        // onRequestError() {
        //     openSnackbar({
        //         state: "error",
        //         description: "Something went wrong, please check your network and try again",
        //     });
        // },
        // onResponseError({ response }) {
        //     openSnackbar({
        //         state: "error",
        //         description: response?._data.error ?? "Something went wrong, Please try again.",
        //     });
        // },
    });

    return {
        provide: {
            publicApi,
        },
    };
});
